"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _pfComponentLibrary = require("@pf-loan-funnel/pf-component-library");
var _ctas = _interopRequireDefault(require("./ctas"));
require("./styles.scss");
/* eslint-disable import/no-unresolved */

var ConfirmApply = function ConfirmApply(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    details = _ref.details,
    chooseAnotherOptionRedirectURL = _ref.chooseAnotherOptionRedirectURL,
    submitApplication = _ref.submitApplication;
  var chooseAnotherOption = function chooseAnotherOption() {
    window.location.href = chooseAnotherOptionRedirectURL;
  };
  return /*#__PURE__*/_react.default.createElement(_reactComponents.App, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "pf-confirm-apply"
  }, /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.PageTitle, {
    title: title,
    subtitle: subTitle
  }), /*#__PURE__*/_react.default.createElement(_pfComponentLibrary.Table, {
    rows: details
  }), /*#__PURE__*/_react.default.createElement(_ctas.default, {
    onConfirmApplyClick: submitApplication,
    onChooseAnotherOptionClick: chooseAnotherOptionRedirectURL ? chooseAnotherOption : null
  })));
};
ConfirmApply.propTypes = {
  title: _propTypes.default.string,
  subTitle: _propTypes.default.string,
  details: _propTypes.default.arrayOf(_propTypes.default.shape({
    header: _propTypes.default.string,
    text: _propTypes.default.string,
    subText: _propTypes.default.string
  })).isRequired,
  chooseAnotherOptionRedirectURL: _propTypes.default.string.isRequired,
  submitApplication: _propTypes.default.func.isRequired
};
ConfirmApply.defaultProps = {
  title: 'Review Your Selection',
  subTitle: 'Confirm your offer before submitting your application.'
};
var _default = exports.default = ConfirmApply;
